import { RuleDto } from './rule.dto';

export class InheritanceDto {
  rules?: RuleDto[];

  constructor(d?: InheritanceDto) {
    if (!d) {
      return;
    }

    this.rules = d.rules ? d.rules.map(r => new RuleDto(r)) : undefined;
  }
}
